export default __webpack_public_path__ + "static/media/icon1_1.c28834b6.svg";